// Schemas for the users domain. Today this is just creation — the
// /users list, /users/:id, and /groups endpoints don't accept request
// bodies. As POST /users/:id (disable/reset) lands, schemas for those
// flows belong here too.
import { z } from 'zod';
// POST /users — create a new user. 0.1.7+ added via the users:create
// capability so emissary / steward / envoy + per-org owners can mint
// accounts from the UI without dropping to the create-user.ts CLI.
//
// Optional fields:
//   - displayName  — derived from the email-prefix when absent
//                    (e.g. "alex@example.com" → "alex").
//   - password     — when absent, the server generates a 16-char
//                    random temp password, hashes it, and returns
//                    the plaintext ONCE in the response. Operator
//                    captures it and hands off; UI shows it in a
//                    copy-once banner. The user's first action is
//                    typically a password change.
/**
 * Strict (CTSK-445) — unknown keys are rejected with 400
 * VALIDATION_ERROR naming the offending key, instead of Zod's default
 * silent strip. Class-fix for the CTSK-427 silent-drop bug (memory
 * feedback_zod_field_name_silent_drop).
 */
export const UserCreateSchema = z.object({
    email: z.string().email().max(254),
    displayName: z.string().min(1).max(120).optional(),
    password: z.string().min(8).max(256).optional(),
    isActive: z.boolean().default(true),
}).strict();
// PATCH /users/:id — partial update. All fields optional. Used by
// the Users admin tab for inline disable/enable, rename, and (later)
// avatar swap. Email changes are allowed but rare; the server checks
// for collisions and rejects 422 if the new email is in use.
//
// Note: password reset doesn't go through here — when it ships it'll
// be POST /users/:id/reset-password so the audit + return-temp-pw
// flow stays distinct from a routine profile edit.
export const UserPatchSchema = z.object({
    email: z.string().email().max(254).optional(),
    displayName: z.string().min(1).max(120).optional(),
    avatarUrl: z.string().url().max(1024).nullable().optional(),
    isActive: z.boolean().optional(),
});
//# sourceMappingURL=user.js.map